import { Textarea as AdsTextarea } from '@ads/components-react';
import { forwardRef } from 'react';

/** Props do componente Textarea */
export interface TextareaProps {
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly readOnly?: boolean;
  readonly value?: string;
  readonly defaultValue?: string;
  readonly rows?: number;
  /** Mensagem de erro — quando presente, exibe borda e ícone de erro (ADS). */
  readonly error?: string;
  readonly onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  readonly onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  readonly name?: string;
  readonly id?: string;
  readonly className?: string;
  readonly 'aria-describedby'?: string;
  readonly 'aria-label'?: string;
}

/**
 * Componente Textarea — campo de texto multilinha.
 *
 * @example
 * ```tsx
 * <Textarea
 *   placeholder="Adicione um comentário..."
 *   rows={4}
 *   {...form.register('comment')}
 * />
 * ```
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      placeholder,
      disabled,
      readOnly,
      value,
      defaultValue,
      rows = 3,
      error,
      onChange,
      onBlur,
      name,
      id,
      className,
      ...ariaProps
    },
    ref,
  ) => {
    return (
      <AdsTextarea
        ref={ref}
        placeholder={placeholder}
        disabled={disabled}
        fullWidth
        readOnly={readOnly ?? false}
        value={value}
        defaultValue={defaultValue}
        rows={rows}
        {...(error !== undefined ? { error } : {})}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        id={id}
        className={className}
        {...ariaProps}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
